import template from './index.html'

import controller from './controller'

config.vsNgType = 'config'
config.vsName = 'conversionDropDown'

config.$inject = ['formlyConfigProvider']
function config(formlyConfigProvider) {
  let type = {
    name: 'conversionDropDown',
    templateUrl: template,
    wrapper: ['bootstrapLabel', 'bootstrapHasError'],
    controller: controller,
    apiCheck: check => ({
      templateOptions: {
        options: check.arrayOf(check.object).optional,
        optionsAttr: check.string.optional,
        labelProp: check.string.optional,
        valueProp: check.string.optional,
        groupProp: check.string.optional
      }
    })
  }
  formlyConfigProvider.setType(type)
}

export default config